import { Component, input } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import {
  faCheckCircle,
  faExclamationCircle,
  faExclamationTriangle,
  faInfoCircle,
} from '@fortawesome/pro-light-svg-icons';

@Component({
  standalone: true,
  selector: 'ct-lib-info-banner',
  templateUrl: './info-banner.component.html',
  styleUrls: ['./info-banner.component.scss'],
  imports: [FaIconComponent],
  host: {
    class: 'd-block mb-3',
  },
})
export class InfoBannerComponent {
  type = input<string | null>(null);
  faInfoCircle = faInfoCircle;
  faExclamationTriangle = faExclamationTriangle;
  faExclamationCircle = faExclamationCircle;
  faCheckCircle = faCheckCircle;
}
